import { render, staticRenderFns } from "./CashierDisplay.vue?vue&type=template&id=9b1a43a0&scoped=true"
import script from "./CashierDisplay.vue?vue&type=script&lang=ts"
export * from "./CashierDisplay.vue?vue&type=script&lang=ts"
import style0 from "./CashierDisplay.vue?vue&type=style&index=0&id=9b1a43a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1a43a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b1a43a0')) {
      api.createRecord('9b1a43a0', component.options)
    } else {
      api.reload('9b1a43a0', component.options)
    }
    module.hot.accept("./CashierDisplay.vue?vue&type=template&id=9b1a43a0&scoped=true", function () {
      api.rerender('9b1a43a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/plugins/CashierDisplay.vue"
export default component.exports